module.exports = {"360926100":"永宁镇","360926101":"温泉镇","360926102":"棋坪镇","360926103":"排埠镇","360926104":"三都镇","360926105":"大塅镇","360926200":"高桥乡","360926201":"港口乡","360926202":"带溪乡","360926404":"江西铜鼓工业园区","360926500":"花山林场","360926501":"大沩山林场","360926502":"茶山林场","360926503":"龙门林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360926.json
// module id = 1437
// module chunks = 0